import { ECountryRegion } from '../../enums/countryRegion.enum';
import { ESegment } from '../../enums/segment.enum';
import { SegmentModel } from './segment.model';
import { SupplierContactFormModel } from './supplierContactForm.model';
import { SupplierSelectionFormModel } from './supplierSelectionForm.model';
import { v4 as uuidv4 } from 'uuid';

export class SupplierCreateRequestModel {
  public companyId: string = uuidv4();
  public companyName: string = '';
  public timestamp: number = new Date().getTime();
  public representativeFirstName: string = '';
  public representativeLastName: string = '';
  public phoneNumber: string = '';
  public mobileNumber: string = '';
  public emailAddress: string = '';
  public street: string = '';
  public postalCode: string = '';
  public city: string = '';
  public country: string = '';
  public website: string = '';
  public segments: SegmentModel[] = [];
  public otherServices: string[] = [];
  public industries: string[] = [];
  public coverADR: boolean = false;
  public regions: { name: string; countries: string[] }[] = [];
  public co2Score: number = 0;
  public co2EmissionTotal: number = 0;
  public scorePlatform: string = '';
  public scorePlatformLink: string = '';
  public logoUploaded: boolean = false;
  public uploadedLogoType: string = '';

  /**
   * Sets the contact-related properties of the supplier create request model.
   * @param {SupplierContactFormModel} data - The supplier contact form model containing the new values.
   * @returns {void}
   *
   */
  public setContactValues(data: SupplierContactFormModel) {
    this.companyName = data.companyName!;
    this.representativeFirstName = data.representativeFirstName!;
    this.representativeLastName = data.representativeLastName!;
    this.phoneNumber = data.phoneNumber!;
    this.mobileNumber = data.mobileNumber!;
    this.emailAddress = data.emailAddress!;
    this.street = data.street!;
    this.postalCode = data.postalCode!;
    this.city = data.city!;
    this.country = data.country!;
    this.website = data.website!;
    this.co2Score = data.co2Score!;
    this.co2EmissionTotal = data.co2EmissionTotal!;
    this.scorePlatform = data.scorePlatform!;
    this.scorePlatformLink = data.scorePlatformLink!;
    this.coverADR = data.coverADR!;
  }

  /**
   * Sets the selection-related properties of the supplier create request model.
   * @param {SupplierSelectionFormModel} data - The supplier selection form model containing the new values.
   * @returns {void}
   */
  public setSelectionValues(data: SupplierSelectionFormModel) {
    this.otherServices = data.services!;
    this.industries = data.industries!;
    this.segments = [
      { name: ESegment.AIR, subSegments: data.segmentsAir! },
      { name: ESegment.SEA, subSegments: data.segmentsSea! },
      { name: ESegment.ROAD, subSegments: data.segmentsRoad! },
      { name: ESegment.RAIL, subSegments: data.segmentsRail! },
    ];
    this.regions = [
      {
        name: ECountryRegion.AFRICA,
        countries: data.regionsAfrica!.map((c) => c.code),
      },
      {
        name: ECountryRegion.ASIA,
        countries: data.regionsAsia!.map((c) => c.code),
      },
      {
        name: ECountryRegion.AUSTRALIA_PACIFIC,
        countries: data.regionsAustraliaPacific!.map((c) => c.code),
      },
      {
        name: ECountryRegion.EUROPE,
        countries: data.regionsEurope!.map((c) => c.code),
      },
      {
        name: ECountryRegion.NORTH_AMERICA,
        countries: data.regionsNorthAmerica!.map((c) => c.code),
      },
      {
        name: ECountryRegion.SOUTH_AMERICA,
        countries: data.regionsSouthAmerica!.map((c) => c.code),
      },
    ];
  }
}
